// Features/Cart/Update.ts
async function update({ updates }) {
  const body = JSON.stringify({ updates });
  const route = window.themeVariables.routes.cartUrl;
  const url = `${route}/update.js`;
  const response = await fetch(url, {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body
  });
  return await response.json();
}
// Features/Cart/Change.ts
async function changeCart(props) {
  const payload = {
    quantity: props.quantity,
    id: props.key
  };
  const body = JSON.stringify(payload);
  const url = window.themeVariables.routes.cartChangeUrl + ".js";
  const response = await fetch(url, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body
  });
  return await response.json();
}
// Features/Cart/Page.ts
import { dispatchCartRefresh } from "Misc";

// Features/Cart/Validate.ts
async function validateCart(cart) {
  if (Freebies.inCustomizer)
    return false;
  if (!Freebies.isEnabled)
    return false;
  if (!Freebies.goals)
    return false;
  if (!cart.item_count)
    return false;
  const { ignored, goals } = Freebies;
  if (!goals.length)
    return false;
  const productIds = goals.map((goal) => goal.productId);
  const { items } = cart;
  let total = 0;
  for (const item of items) {
    const { product_id } = item;
    if (productIds.includes(product_id))
      continue;
    if (ignored.includes(product_id))
      continue;
    total += item.final_line_price;
  }
  const updates = {};
  for (const goal of goals) {
    const { threshold, productId, variantId } = goal;
    let quantity = 0;
    for (const item of items)
      if (item.product_id === productId)
        quantity += item.quantity;
    if (total >= threshold) {
      if (quantity === 1)
        continue;
      if (quantity === 0) {
        updates[variantId] = 1;
        continue;
      }
      let first = true;
      for (const item of items) {
        if (item.product_id !== productId)
          continue;
        const quantity2 = first ? 1 : 0;
        first = false;
        updates[item.key] = quantity2;
      }
    } else {
      if (quantity === 0)
        continue;
      for (const item of items)
        if (item.product_id === productId)
          updates[item.key] = 0;
    }
  }
  const noChanges = !Object.keys(updates).length;
  if (noChanges)
    return false;
  await update({ updates });
  return true;
}

// Features/Cart/Query.ts
var route = window.themeVariables.routes.cartUrl + ".js";
var url = new URL(route, window.location.href);
var request = new Request(url, {
  cache: "reload"
});
async function query() {
  let cart = await fetchCart();
  const refetch = await validateCart(cart);
  if (refetch)
    cart = await fetchCart();
  return cart;
}
async function fetchCart() {
  return await fetch(request).then((response) => response.json()).then((json) => json);
}

// Features/Cart/Page.ts
async function refreshCart(args) {
  let openBasket = false;
  if ("openBasket" in args)
    openBasket = args?.openBasket ?? false;
  const cart = await fetchCart();
  dispatchCartRefresh({ openBasket, cart });
}
// Features/Cart/Add.ts
async function addCart(props) {
  const { variantId, quantity } = props;
  const payload = {
    items: [{
      quantity,
      id: variantId
    }]
  };
  const body = JSON.stringify(payload);
  const url2 = window.themeVariables.routes.cartAddUrl + ".js";
  return await fetch(url2, {
    headers: { "Content-Type": "application/json" },
    method: "POST",
    body
  });
}
// Features/Cart/mod.ts
var _Cart = {
  integrated: false,
  query,
  fetchCart
};
window.Cart = _Cart;
window.addEventListener("pageshow", refreshCart);
export {
  update as updateCart,
  refreshCart,
  changeCart,
  addCart
};
